import React from "react";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import Switch from "theme/components/atoms/Switch";
import EditorialToolboxSection from "theme/components/molecules/EditorialToolboxSection";
import FrontCommerceIcon from "theme/components/atoms/FrontCommerceIcon";
import {
  AUTO_REFRESH_INTERVAL_SECONDS,
  useEditorialToolbox,
} from "theme/components/molecules/EditorialToolbox/EditorialToolboxProvider";

const messages = defineMessages({
  generalSettings: {
    id: "components.molecules.EditorialToolbox.generalSettings",
    defaultMessage: "General Settings",
  },
  autoRefresh: {
    id: "components.molecules.EditorialToolbox.autoRefresh",
    defaultMessage: "Auto Refresh",
  },
  autoRefreshDescription: {
    id: "components.molecules.EditorialToolbox.autoRefreshDescription",
    defaultMessage:
      "Reload the data on the current page, every {delay} seconds when preview mode is active",
  },
  previewMode: {
    id: "components.molecules.EditorialToolbox.previewMode",
    defaultMessage: "Preview Mode",
  },
  previewModeDescription: {
    id: "components.molecules.EditorialToolbox.previewModeDescription",
    defaultMessage:
      "Allows you to see the changes you are making to the website in real time.",
  },
  xRay: {
    id: "components.molecules.EditorialToolbox.xRay",
    defaultMessage: "X-Ray",
  },
  xRayDescription: {
    id: "components.molecules.EditorialToolbox.xRayDescription",
    defaultMessage:
      "Display boundaries and edit link for content displayed on the page.",
  },
});

const EditorialToolbox = () => {
  const intl = useIntl();
  const editorialToolbox = useEditorialToolbox();
  return (
    <div className="editorial-toolbox">
      <header className="editorial-toolbox__header">
        <FrontCommerceIcon size={24} />{" "}
        <FormattedMessage
          id="components.molecules.EditorialToolbox.header"
          defaultMessage="Editorial Toolbox"
        />
      </header>
      <EditorialToolboxSection
        title={intl.formatMessage(messages.generalSettings)}
      >
        <Switch
          title={intl.formatMessage(messages.previewMode)}
          description={intl.formatMessage(messages.previewModeDescription)}
          checked={editorialToolbox.isPreviewMode}
          onChange={(newEnabledState) => {
            editorialToolbox.setPreviewMode(newEnabledState);
          }}
        />
        <Switch
          title={intl.formatMessage(messages.autoRefresh)}
          description={intl.formatMessage(messages.autoRefreshDescription, {
            delay: AUTO_REFRESH_INTERVAL_SECONDS,
          })}
          checked={editorialToolbox.isAutoRefreshing}
          onChange={(newEnabledState) => {
            editorialToolbox.setAutoRefreshing(newEnabledState);
          }}
        />
        <Switch
          title={intl.formatMessage(messages.xRay)}
          description={intl.formatMessage(messages.xRayDescription)}
          checked={editorialToolbox.isXRayMode}
          onChange={(newEnabledState) => {
            editorialToolbox.setXRayMode(newEnabledState);
          }}
        />
      </EditorialToolboxSection>
    </div>
  );
};

export default EditorialToolbox;
